<template>
  <transition name="fade">
    <div class="c-message c-message--error">
      <span>{{ $t('error.error')}}</span>
      <p>{{ errorMessage }}<br />
      {{ $t('error.contactServiceDesk') }}</p>
      <button class="btn btn-transparent" type="button" @click="handleClose" aria-label="Close">
        <svg class="icon icon-error" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 33 33">
          <g transform="translate(1 1)">
            <path d="M15.5,32C6.4,32-1,24.6-1,15.5C-1,6.4,6.4-1,15.5-1C24.6-1,32,6.4,32,15.5C32,24.6,24.6,32,15.5,32z M15.5,0
              C6.95,0,0,6.95,0,15.5S6.95,31,15.5,31S31,24.05,31,15.5S24.05,0,15.5,0z"/>
            <polygon points="21.15,21.85 15.15,15.86 9.15,21.85 8.45,21.15 14.44,15.15 8.45,9.15 9.15,8.45 15.15,14.44
              21.15,8.45 21.85,9.15 15.86,15.15 21.85,21.15"/>
          </g>
        </svg>
      </button>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ErrorBoundary',
  props: {
    errorMessage: String,
  },
  methods: {
    handleClose() {
      this.$emit('alert-error-closed');
    },
  },
};
</script>
<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
